<div class="input-container" [ngClass]="{'mobile-responsive': mobileResponsive}">
  <input [type]="type" class="custom-input" [placeholder]="placeholder" [style.width]="width" [style.height]="height"
    [(ngModel)]="value" (ngModelChange)="updateValue($event)" [tabindex]="tabindex" [maxlength]="maxlength" [autocapitalize]="autocapitalize" [autocomplete]="autocomplete">
</div>
